<template>
  <div
    id="productModule"
    class="productModuleContainer"
    style="position: relative"
  >
    <div class="fake-scrollbar mobile">
      <div class="fake-thumb"></div>
    </div>
    <div class="product-box">
      <div
        class="product-table scroll-fade-up"
      >
        <div class="product-table-th">
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            交易产品
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            卖出价
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            买入价
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            点差
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            杠杆
          </div>
          <div class="product-table-td body-16_regular md-footnote-medium_12">
            流动性深度
          </div>
        </div>
        <div
          class="product-table-row"
          v-for="(item, index) in isMoible
            ? showData.slice(
                (targetNavigationIndex - 1) * 6,
                (targetNavigationIndex - 1) * 6 + 6
              )
            : showData"
          :key="index"
        >
          <div
            class="product-table-tr"
            v-show="(index > 7 && showMore) || index <= 7 || tabIndex <3"
            @click="showFormPopup(index)"
          >
            <div class="product-table-td subtitle-20_medium md-body-14_medium">
              {{ item.symbolZh || item.symbol }}
            </div>
            <div
              class="product-table-td body-16_medium md-body-14_medium"
              :class="[item.tick[0].bidClassName]"
            >
              {{ item.tick[0].bid_price }}
            </div>

            <div
              class="product-table-td body-16_medium md-body-14_medium"
              :class="[item.tick[0].askClassName]"
            >
              {{ item.tick[0].ask_price }}
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium">
              {{ item.tick[0].spread }}
            </div>
            <div class="product-table-td body-16_medium md-body-14_medium" v-html="item.rule">
            </div>

            <div
              class="
                product-table-td
                body-16_medium
                md-footnote-medium_12
                cursor-pointer
              "
            >
              查看
              <span class="iconfont icon-a-down rotate90"></span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="iBtn secondary-default_large"
        v-if="tabIndex == 3 || tabIndex == 4"
        @click="showMore = !showMore"
      >
        查看所有产品
        <span
          class="iconfont icon-a-down"
          :class="{ rotate180: showMore }"
        ></span>
      </div>
      <div
        class="formPopup box-border"
        :class="{ showFormPopup: popupControl }"
      >
        <span class="formPopupClose" @click="closePopup">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          >
            <g clip-path="url(#clip0_4123_9841)">
              <path
                d="M23.2893 7.29284C23.6798 6.90235 24.3128 6.90242 24.7034 7.29284C25.0939 7.68336 25.0939 8.31637 24.7034 8.7069L17.4104 15.9999L24.7034 23.2928L24.7724 23.369C25.0925 23.7617 25.0694 24.3408 24.7034 24.7069C24.3374 25.0727 23.7582 25.0959 23.3655 24.7759L23.2893 24.7069L15.9964 17.4139L8.70341 24.7069C8.31287 25.0972 7.67983 25.0973 7.28935 24.7069C6.89898 24.3164 6.899 23.6833 7.28935 23.2928L14.5823 15.9999L7.28935 8.7069C6.89898 8.31641 6.899 7.68334 7.28935 7.29284C7.67984 6.90235 8.31288 6.90242 8.70341 7.29284L15.9964 14.5858L23.2893 7.29284Z"
                fill="black"
                fill-opacity="0.48"
              />
            </g>
            <defs>
              <clipPath id="clip0_4123_9841">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
        <h2 class="title-32_bold md-title-24_medium">实时报价深度</h2>
        <h3 class="body-16_regular md-footnote-regular_12">
          EBC直连25+顶级流动性，基于专业HUB硬件和交易黑盒抛单算法，提供五档报价深度，实时透明呈现市场流动性层级。
        </h3>
        <div class="innerTableContainer" style="position: relative">
          <div class="fake-scrollbar mobile">
            <div class="fake-thumb"></div>
          </div>
          <div
            class="product-table"
            :class="{ 'grow-product-table': tabIndex == 3 || tabIndex == 4 }"
          >
            <div class="product-table-row">
              <div class="product-innertable body-16_medium">
                <div class="product-innertable-th md-footnote-medium_12">
                  <div class="product-innertable-td">
                    layer
                    <span
                      class="iconfont icon-a-tipsicon cursor-pointer"
                      data-popover="p1"
                    ></span>
                  </div>
                  <div class="product-innertable-td">Bid</div>
                  <div
                    class="product-innertable-td"
                    v-if="tabIndex != 3 && tabIndex != 4"
                  >
                    Bid Volume
                  </div>
                  <div class="product-innertable-td">Ask</div>
                  <div
                    class="product-innertable-td"
                    v-if="tabIndex != 3 && tabIndex != 4"
                  >
                    Ask Volume
                  </div>
                  <div class="product-innertable-td">Spread</div>
                </div>
                <div class="product-innertable-tbody">
                  <div
                    class="product-innertable-tr md-body-14_medium"
                    v-for="(el, i) in innerTickList"
                    :key="i"
                  >
                    <div class="product-innertable-td">{{ i + 1 }}</div>
                    <div
                      class="product-innertable-td"
                      :class="[el.bidClassName]"
                    >
                      {{ el.bid_price }}
                    </div>
                    <div
                      class="product-innertable-td"
                      v-if="tabIndex != 3 && tabIndex != 4"
                    >
                      {{ el.bid_size ? el.bid_size : "-" }}
                    </div>
                    <div
                      class="product-innertable-td"
                      :class="[el.askClassName]"
                    >
                      {{ el.ask_price }}
                    </div>
                    <div
                      class="product-innertable-td"
                      v-if="tabIndex != 3 && tabIndex != 4"
                    >
                      {{ el.ask_size ? el.ask_size : "-" }}
                    </div>
                    <div class="product-innertable-td">{{ el.spread }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="pageNavigation flex justify-center items-center">
        {{ visiblePages }}
        <span
          class="iconfont icon-a-down"
          :class="{ notAllow: targetNavigationIndex == 1 }"
          style="transform: rotate(90deg)"
          @click="targetNavigationIndex = targetNavigationIndex - 1"
        ></span>
        <div
          v-for="item in visiblePages"
          class="md-footnote-regular_12"
          :class="targetNavigationIndex == item ? 'active' : ''"
          @click="setTargetNavigationIndex(item)"
        >
          {{ item == 0 ? "..." : item }}
        </div>
        <span
          class="iconfont icon-a-down"
          :class="{ notAllow: targetNavigationIndex == pageNavigationNumber }"
          style="transform: rotate(-90deg)"
          @click="targetNavigationIndex = targetNavigationIndex + 1"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
const myEvent = new CustomEvent("mountedSuccess", {
  detail: true,
  bubbles: false,
  cancelable: true,
});
export default {
  name: "product-module-new",
  data() {
    return {
      msg: "测试",
      tabList: ["Forex", "Indices", "Commodities", "Stock CFDs", "ETF CFDs"],
      tableData: [
        {
          tabName: "Forex",
          datas: [
            { symbol: "EURUSD", tick: [], symbolZh: "欧元/美元" },
            { symbol: "AUDUSD", tick: [], symbolZh: "澳元/美元" },
            { symbol: "GBPUSD", tick: [], symbolZh: "英镑/美元" },
            { symbol: "NZDUSD", tick: [], symbolZh: "纽元/美元" },
            { symbol: "USDCAD", tick: [], symbolZh: "美元/瑞郎" },
            { symbol: "USDJPY", tick: [], symbolZh: "美元/加元" },
            { symbol: "USDCHF", tick: [], symbolZh: "美元/日元" },
            { symbol: "GBPAUD", tick: [], symbolZh: "英镑/澳元" },
            { symbol: "GBPJPY", tick: [], symbolZh: "英镑/日元" },
          ],
        },
        {
          tabName: "Indices",
          datas: [
            { symbol: "100GBP", tick: [], symbolZh: "富时100指数" },
            { symbol: "200AUD", tick: [], symbolZh: "S&P200指数" },
            { symbol: "225JPY", tick: [], symbolZh: "日经225指数" },
            { symbol: "D30EUR", tick: [], symbolZh: "DAX30指数" },
            { symbol: "E50EUR", tick: [], symbolZh: "STOXX50指数" },
            { symbol: "F40EUR", tick: [], symbolZh: "CAC40指数" },
            { symbol: "HSIHKD", tick: [], symbolZh: "恒生指数" },
            { symbol: "NASUSD", tick: [], symbolZh: "纳斯达克指数" },
            { symbol: "SPXUSD", tick: [], symbolZh: "标普500指数" },
            { symbol: "U30USD", tick: [], symbolZh: "道琼斯指数" },
          ],
        },
        {
          tabName: "Commodities",
          datas: [
            { symbol: "XAUUSD", tick: [], symbolZh: "黄金/美元" },
            { symbol: "XAGUSD", tick: [], symbolZh: "白银/美元" },
            { symbol: "XBRUSD", tick: [], symbolZh: "布伦特原油" },
            { symbol: "XTIUSD", tick: [], symbolZh: "WTI原油" },
            { symbol: "XNGUSD", tick: [], symbolZh: "天然气" },
          ],
        },
        {
          tabName: "Stock CFDs",
          datas: [
            { symbol: "AAPL", tick: [] },
            { symbol: "ADBE", tick: [] },
            { symbol: "AMGN", tick: [] },
            { symbol: "AMZN", tick: [] },
            { symbol: "CMCSA", tick: [] },
            { symbol: "CSCO", tick: [] },
            { symbol: "GOOGL", tick: [] },
            { symbol: "HON", tick: [] },
            { symbol: "INTC", tick: [] },
            { symbol: "META", tick: [] },
            { symbol: "MSFT", tick: [] },
            { symbol: "NFLX", tick: [] },
            { symbol: "NVDA", tick: [] },
            { symbol: "PEP", tick: [] },
            { symbol: "PYPL", tick: [] },
            { symbol: "TSLA", tick: [] },
            { symbol: "TXN", tick: [] },
            { symbol: "ABT", tick: [] },
            { symbol: "BA", tick: [] },
            { symbol: "BAC", tick: [] },
            { symbol: "BMY", tick: [] },
            { symbol: "BRKb", tick: [] },
            { symbol: "CAT", tick: [] },
            { symbol: "CRM", tick: [] },
            { symbol: "CVX", tick: [] },
            { symbol: "DIS", tick: [] },
            { symbol: "GE", tick: [] },
            { symbol: "GS", tick: [] },
            { symbol: "HD", tick: [] },
            { symbol: "IBM", tick: [] },
            { symbol: "JNJ", tick: [] },
            { symbol: "JPM", tick: [] },
            { symbol: "KO", tick: [] },
            { symbol: "LLY", tick: [] },
            { symbol: "LMT", tick: [] },
            { symbol: "MA", tick: [] },
            { symbol: "MCD", tick: [] },
            { symbol: "MDT", tick: [] },
            { symbol: "MMM", tick: [] },
            { symbol: "MRK", tick: [] },
            { symbol: "MS", tick: [] },
            { symbol: "NEE", tick: [] },
            { symbol: "PFE", tick: [] },
            { symbol: "PG", tick: [] },
            { symbol: "RTX", tick: [] },
            { symbol: "UNH", tick: [] },
            { symbol: "V", tick: [] },
            { symbol: "VZ", tick: [] },
            { symbol: "WMT", tick: [] },
            { symbol: "XOM", tick: [] },
          ],
        },
        {
          tabName: "ETF CFDs",
          datas: [
            // {symbol:"AGG", tick:[] },
            { symbol: "AGG", tick: [] },
            { symbol: "BIL", tick: [] },
            { symbol: "BSV", tick: [] },
            { symbol: "DGRO", tick: [] },
            { symbol: "DIA", tick: [] },
            { symbol: "EEM", tick: [] },
            { symbol: "EFA", tick: [] },
            { symbol: "EWT", tick: [] },
            { symbol: "EWW", tick: [] },
            { symbol: "EWY", tick: [] },
            { symbol: "EWZ", tick: [] },
            { symbol: "FVD", tick: [] },
            { symbol: "FXI", tick: [] },
            { symbol: "GDX", tick: [] },
            { symbol: "GDXJ", tick: [] },
            { symbol: "GLD", tick: [] },
            { symbol: "HDV", tick: [] },
            { symbol: "HYG", tick: [] },
            { symbol: "IEMG", tick: [] },
            { symbol: "IJH", tick: [] },
            { symbol: "IJR", tick: [] },
            { symbol: "ITOT", tick: [] },
            { symbol: "IVE", tick: [] },
            { symbol: "IVV", tick: [] },
            { symbol: "IVW", tick: [] },
            { symbol: "IWB", tick: [] },
            { symbol: "IWD", tick: [] },
            { symbol: "IWF", tick: [] },
            { symbol: "IWM", tick: [] },
            { symbol: "IWN", tick: [] },
            { symbol: "IWS", tick: [] },
            { symbol: "LQD", tick: [] },
            { symbol: "MDY", tick: [] },
            { symbol: "RSP", tick: [] },
            { symbol: "SCHB", tick: [] },
            { symbol: "SCHD", tick: [] },
            { symbol: "SCHF", tick: [] },
            { symbol: "SCHG", tick: [] },
            { symbol: "SCHX", tick: [] },
            { symbol: "SDY", tick: [] },
            { symbol: "SPDW", tick: [] },
            { symbol: "SPY", tick: [] },
            { symbol: "SPYG", tick: [] },
            { symbol: "SPYV", tick: [] },
            { symbol: "TIP", tick: [] },
            { symbol: "UNG", tick: [] },
            { symbol: "URA", tick: [] },
            { symbol: "USO", tick: [] },
            { symbol: "VB", tick: [] },
            { symbol: "VDE", tick: [] },
            { symbol: "VEA", tick: [] },
            { symbol: "VEU", tick: [] },
            { symbol: "VGT", tick: [] },
            { symbol: "VHT", tick: [] },
            { symbol: "VIG", tick: [] },
            { symbol: "VNQ", tick: [] },
            { symbol: "VO", tick: [] },
            { symbol: "VOE", tick: [] },
            { symbol: "VOO", tick: [] },
            { symbol: "VT", tick: [] },
            { symbol: "VTI", tick: [] },
            { symbol: "VTV", tick: [] },
            { symbol: "VUG", tick: [] },
            { symbol: "VWO", tick: [] },
            { symbol: "VXF", tick: [] },
            { symbol: "VYM", tick: [] },
            { symbol: "XLB", tick: [] },
            { symbol: "XLE", tick: [] },
            { symbol: "XLF", tick: [] },
            { symbol: "XLI", tick: [] },
            { symbol: "XLK", tick: [] },
            { symbol: "XLP", tick: [] },
            { symbol: "XLU", tick: [] },
            { symbol: "XLV", tick: [] },
            { symbol: "XLY", tick: [] },
            { symbol: "AAXJ", tick: [] },
            { symbol: "ACWI", tick: [] },
            { symbol: "BND", tick: [] },
            { symbol: "BNDX", tick: [] },
            { symbol: "DVY", tick: [] },
            { symbol: "EMB", tick: [] },
            { symbol: "IBB", tick: [] },
            { symbol: "ICLN", tick: [] },
            { symbol: "IEI", tick: [] },
            { symbol: "INDY", tick: [] },
            { symbol: "IUSG", tick: [] },
            { symbol: "IUSV", tick: [] },
            { symbol: "MCHI", tick: [] },
            { symbol: "PFF", tick: [] },
            { symbol: "QQQ", tick: [] },
            { symbol: "SHV", tick: [] },
            { symbol: "SHY", tick: [] },
            { symbol: "SKYY", tick: [] },
            { symbol: "SMH", tick: [] },
            { symbol: "SOXX", tick: [] },
            { symbol: "TLT", tick: [] },
            { symbol: "TQQQ", tick: [] },
            { symbol: "VCIT", tick: [] },
            { symbol: "VCSH", tick: [] },
            { symbol: "VXUS", tick: [] },
          ],
        },
        {
          tabName: "Crypto",
          datas: [{ symbol: "BTCUSD", tick: [], symbolZh: "比特币" }],
        },
      ],
      tabIndex: 0,
      dataIndex: 0,
      showMore: false,
      innerTableFn: "",
      popupControl: false,
      innerTickIndex: 0,
      targetNavigationIndex: 1,
      isMoible: false,
      lastClickTime:0
    };
  },
  computed: {
    showData() {
      return this.tableData[
        this.tabIndex == 1 ? 2 : this.tabIndex == 2 ? 1 : this.tabIndex
      ].datas.filter((item) => {
        return item.tick && item.tick.length;
      });
    },
    innerTickList(){
         const item = this.showData[this.innerTickIndex];
    return (item && item.tick) || [];
    },
    pageNavigationNumber() {
      return Math.ceil(this.showData.length / 6);
    },
    visiblePages() {
      const total = this.pageNavigationNumber;
      const c = this.targetNavigationIndex;
      if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
      if (c <= 3) return [1, 2, 3, 0, total]; // 0 代表 …
      if (c >= total - 2) return [1, 0, total - 2, total - 1, total];
      return [1, 0, c - 1, c, c + 1, 0, total]; // 7 项
    },
  },
  created() {
    this.tableData.forEach((item, index) => {
      item.datas.forEach((data) => {
        data.rule = this.rulesData(
          data.symbol,
          index == 1 ? 2 : index == 2 ? 1 : index
        );
      });
    });
    this.getListData();
    let time = new Date().getMilliseconds();
    this.$http("/ebc/api/getToken/run", {
      date: time,
      CheckSum: md5(time + "YISENCE"),
    }).then((res) => {
      let url = "wss://pricecloud.eappservice.com/ws?token=" + res.data.data;
      this.createWebSocket(url);
    });
    // ;
  },
  mounted() {
    const pageOverlay = document.getElementById("pageOverLay");
    let that = this;
    
    this.mountPopover();
    this.setPopover();
    let timer;
    window.addEventListener("resize", () => {
      clearTimeout(timer);
      timer = setTimeout(() => that.checkMobile(), 200);
    });
    that.checkMobile()
    window.ProductVM = this;
    document.dispatchEvent(myEvent);
  },
  methods: {
    mountPopover() {
      const div = document.createElement("div");
      div.className = "popover body-14_regular text-center";
      div.id = "p1";
      div.innerHTML =
        "订单中的流动性报价层级，展现了市场中最优订单数量，其中第一层是头层报价，提供真正机构原始点差。";

      // 插到 body
      document.body.appendChild(div);
    },
    rulesData(symbol, tabIndex) {
      console.log()
      if (tabIndex == 0) {
        return "500:1";
      } else if (tabIndex == 1) {
        const normalRules = {
          XAUUSD: "500:1",
          XAGUSD: "500:1",
          XBRUSD: "100:1",
          XTIUSD: "50:1",
          XNGUSD: "100:1",
        };
        return normalRules[symbol];
      } else if (tabIndex == 2) {
        return "100:1";
      } else if (tabIndex == 5) {
        return "200:1 <span> *</span>";
      } else {
        return "5:1";
      }
    },
    syncFakeScroll(wrapperSel, scrollSel) {
      const wrap = document.querySelector(wrapperSel);
      const scroll = wrap.querySelector(scrollSel || ".product-box");
      const track = wrap.querySelector(".fake-scrollbar");
      const thumb = wrap.querySelector(".fake-thumb");
      function sync() {
        const w = scroll.clientWidth;
        const sw = scroll.scrollWidth;
        const l = scroll.scrollLeft;
        const maxL = sw - w;
        if (maxL <= 0) {
          thumb.style.width = "0px";
          track.style.display = "none";
          wrap.classList.add("noScroll");
          return;
        }

        const thumbW = (w / sw) * track.clientWidth;
        thumb.style.width = thumbW + "px";
        const maxMove = track.clientWidth - thumbW;
        if (l <= 0) {
          wrap.classList.add("noScroll");
        } else {
          wrap.classList.remove("noScroll");
        }
        thumb.style.transform = `translateX(${(l / maxL) * maxMove}px)`;
      }

      scroll.addEventListener("scroll", sync, { passive: true });
      scroll.addEventListener("resize", sync);
      sync();
      return sync;
    },
    lock() {
      const pageOverlay = document.getElementById("pageOverLay");

      document.documentElement.classList.add("no-scroll");
      pageOverlay.style.display = "block";
      setTimeout(() => {
        pageOverlay.style.opacity = 1;
      }, 100);
    },
    unlock() {
      const pageOverlay = document.getElementById("pageOverLay");

      pageOverlay.style.opacity = 0;
      setTimeout(() => {
        pageOverlay.style.display = "none";
        document.documentElement.classList.remove("no-scroll");
      }, 700);
    },
    showFormPopup(data) {
      if((Date.now() - this.lastClickTime) < 500) return;
      this.lastClickTime = Date.now();
      this.innerTickIndex = data;
      this.popupControl = true;
      this.lock();
      setTimeout(() => {
        this.innerTableFn();
      });
    },
    closePopup() {
      this.popupControl = false;
      this.unlock();
    },
    setPopover() {
      const po = document.getElementById("p1");
      const popover = document.querySelector('[data-popover="p1"]');
      let ifShow = false;
      function place() {
        const r = popover.getBoundingClientRect();
        if (window.matchMedia("(max-width:996px)").matches) {
          po.style.left = r.left + 18 + "px";
          po.style.top = r.bottom - po.offsetHeight / 2 - 20 + "px";
          return;
        }

        po.style.left = r.left - 20 + "px";
        po.style.top = r.bottom - 5 + "px";
      }
      function show() {
        if (ifShow) return;
        ifShow = true;
        place();
        po.classList.add("show");
      }
      function hide() {
        if (!ifShow) return;
        ifShow = false;
        po.classList.remove("show");
      }
      if (window.matchMedia("(max-width:996px)").matches) {
        popover.addEventListener("click", (e) => {
          e.stopPropagation();
          show();
        });
        document.addEventListener("click", () => {
          if (ifShow) hide();
        });
        return;
      }
      popover.addEventListener("mouseenter", show);
      popover.addEventListener("mouseleave", hide);
      po.addEventListener("mouseenter", show);
      po.addEventListener("mouseleave", hide);
    },
    setTargetNavigationIndex(index) {
      this.targetNavigationIndex = index;
    },
    checkMobile() {
      const mobile = window.innerWidth < 996;
      if (mobile !== this.isMobile) {
        this.isMoible = mobile;
      }
    },

    changeInnerTable(index) {
      if (this.dataIndex == index) {
        this.dataIndex = -1;
      } else {
        this.dataIndex = index;
      }
    },
    changeHandle(index) {
      this.dataIndex = 0;
      this.tabIndex = index;
      this.targetNavigationIndex = 1;
      this.showMore = false;
    },
    // 传入ask,bid,返回点差Spread
    getSpread(t, e) {
      var o = /^\+?[1-9][0-9]*$/,
        r = 0,
        d = 0,
        c = 0;
      return (
        o.test(t) || (d = t.toString().split(".")[1].length),
        o.test(e) || (c = e.toString().split(".")[1].length),
        d > c
          ? 1 === d
            ? (r = 10 * t - 10 * e)
            : 2 === d
            ? (r = 100 * t - 100 * e)
            : 3 === d
            ? (r = 1e3 * t - 1e3 * e)
            : 4 === d
            ? (r = 1e4 * t - 1e4 * e)
            : 5 === d && (r = 1e5 * t - 1e5 * e)
          : 1 === c
          ? (r = 10 * t - 10 * e)
          : 2 === c
          ? (r = 100 * t - 100 * e)
          : 3 === c
          ? (r = 1e3 * t - 1e3 * e)
          : 4 === c
          ? (r = 1e4 * t - 1e4 * e)
          : 5 === c && (r = 1e5 * t - 1e5 * e),
        r.toFixed(0)
      );
    },
    // 比较大小返回对应类名
    compareValues(value1, value2, className = "") {
      // 尝试将两个值转换为数字
      const num1 = Number(value1);
      const num2 = Number(value2);

      // 检查转换后的值是否都是有效的数字
      if (!isNaN(num1) && !isNaN(num2)) {
        if (num1 >= num2) {
          return "product-green";
        } else if (num1 < num2) {
          return "product-red";
        } else {
          // 两者相等的情况
          return className;
        }
      }

      // 如果转换后不是有效数字，则返回空字符串
      return "";
    },
    updateTick(symbolToUpdate, newTickValue) {
      newTickValue = newTickValue.map((el) => {
        return {
          ...el,
          spread: this.getSpread(el.ask_price, el.bid_price),
        };
      });
      // 遍历tableData中的每个tab
      this.tableData.some((tab) => {
        // 查找datas数组中匹配symbol的项
        const itemIndex = tab.datas.findIndex(
          (item) => item.symbol === symbolToUpdate
        );

        if (itemIndex !== -1) {
          // 如果找到了匹配的项
          // 使用Vue.set确保响应式更新
          // console.log("tab", tab.datas, itemIndex, newTickValue);
          newTickValue = newTickValue.map((tickItem, index) => {
            let t = {
              askClassName: this.compareValues(tickItem.ask_price),
              bidClassName: this.compareValues(tickItem.bid_price),
              ...tickItem,
            };
            if (tab.datas[itemIndex].tick[index]) {
              t = {
                askClassName: this.compareValues(
                  tickItem.ask_price,
                  tab.datas[itemIndex].tick[index].ask_price,
                  tab.datas[itemIndex].tick[index].askClassName
                ),
                bidClassName: this.compareValues(
                  tickItem.bid_price,
                  tab.datas[itemIndex].tick[index].ask_price,
                  tab.datas[itemIndex].tick[index].bidClassName
                ),
                ...tickItem,
              };
            }

            return t;
          });
          this.$set(tab.datas, itemIndex, {
            ...tab.datas[itemIndex], // 保留原有数据
            tick: newTickValue, // 更新tick值
          });
          return true; // 找到后退出some循环
        }
      });
    },
    createWebSocket(url) {
      let _this = this;
      var ws = new WebSocket(url);

      ws.onopen = function () {
        ws.send("连接成功");
      };
      let f = true;
      ws.onmessage = function (event) {
        try {
          var data = JSON.parse(event.data);
        } catch (e) {
          return false;
        }
        _this.updateTick(data.symbol, data.tick);
      };

      ws.onerror = function (event) {};

      ws.onclose = function () {};
    },
    // 获取历史数据列表
    getListData() {
      fetch("https://www.ebccfd.com/portal/api/getSymbolAll", {
        method: "get",
      })
        .then((response) => {
          // 检查请求是否成功
          if (!response.ok) {
            throw new Error(
              "Network response was not ok " + response.statusText
            );
          }
          // 将 Response 对象转换为 JSON 对象
          return response.json();
        })
        .then((response) => {
          let data = response.rows;
          console.log("getSymbolAll data", data);
          data.map((item) => {
            let t = {
              symbol: item.displaySymbol,
              time: new Date(item.updateTime).getTime(),
              tick: [
                {
                  ask_price: item.ask,
                  ask_size: "",
                  bid_price: item.bid,
                  bid_size: "",
                  spread: this.getSpread(item.ask, item.bid),
                },
              ],
            };
            this.updateTick(t.symbol, t.tick);
          });
          let that = this
          setTimeout(() => {
                that.syncFakeScroll('.productModuleContainer');
                that.innerTableFn = that.syncFakeScroll('.innerTableContainer','.product-table')
              })
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss">

.no-scroll {
  overflow: hidden;
}
.popover {
  --shadow: rgba(0, 0, 0, 0.6);
  --arrow-shadow: rgba(0, 0, 0, 0.5);
}

.popover {
  position: fixed;
  margin-top: 8px;
  padding: 8px 12px;
  color: var(--ebc-text-primary_white);
  background: var(--ebc-neutral-bg_d);
  border-radius: var(--ebc-corner-radius-rc04);
  box-shadow: 0 2px 8px var(--shadow);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s;
  max-width: 500rem;
  z-index: 99999999;
  text-align: left;
  font-size: 14rem;
  line-height: 22rem;
}
.popover.show {
  opacity: 1;
  visibility: visible;
}

/* 阴影三角 + 本体三角 */
.popover::before,
.popover::after {
  content: "";
  position: absolute;
  left: 28px;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid var(--ebc-neutral-bg_d);
}
.ar.popover::before,
.ar.popover::after {
  left: unset;
  right: 28px;
}
.popover::before {
  top: -7px;
}
.popover::after {
  top: -6px;
}
.formPopup {
  border-radius: var(--ebc-corner-radius-rc24);
  background: var(--ebc-basecolor-white-100);
  box-shadow: 20px 40px 60px 0 rgba(0, 0, 0, 0.1);
  width: 1000rem;
  /* height: fit-content; */
  padding: 32rem;
  position: fixed;
  z-index: -1;
  left: 50%;
  top: 240rem;
  transform: translate(-50%, 0) scale(0.1);
  opacity: 0;
  transition: bottom 0.3s ease-in-out, opacity 0.3s ease-in-out,
    transform 0.3s ease-in-out;
  transform-origin: center;
}
.formPopup svg{
    cursor: pointer;
}
@media (max-height: 850px) and (min-width: 996px) {
  .formPopup {
    top: 160rem;
  }
}
.formPopup svg {
  position: absolute;
  top: 24rem;
  right: 24rem;
  width: 32rem;
  height: 32rem;
}
.ar .formPopup svg {
  right: unset;
  left: 24rem;
}

.formPopup h3 {
  margin: 16rem 0 32rem;
}
.showFormPopup {
  z-index: 999999;
  opacity: 1;
  transform: translate(-50%, 0%) scale(1);
}

#productModule {
  margin-top: 60rem;
}

#productModule .product-box {
  width: 1200rem;
  margin: 0 auto;
}

#productModule .iBtn {
  border: 0;
  margin: 20rem auto;
}

#productModule .product-table-th {
  display: flex;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
@media (min-width: 996px) {
  #productModule .product-table-th {
    background: var(--ebc-neutral-bg_c);
    border-top-left-radius: var(--ebc-corner-radius-rc16);
    border-top-right-radius: var(--ebc-corner-radius-rc16);
  }
  #productModule .product-box {
    width: 996rem;
    margin-inline: auto;
  }
}
#productModule .product-table-th .product-table-td {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1.5;
  color: var(--ebc-text-primary);
  padding: 27rem 0;
}
#productModule.jp .product-table-tr .product-table-td,
#productModule.jp .product-table-th .product-table-td {
  flex: 2;
}

#productModule .product-table-th .product-table-td:first-child {
  flex: 4;
  justify-content: flex-start;
  padding-left: 24rem;
}
#productModule.ar .product-table-tr .product-table-td:first-child,
#productModule.ar .product-table-th .product-table-td:first-child {
  padding-right: 24rem;
}

#productModule .product-table-th .product-table-td:nth-child(2),
#productModule .product-table-th .product-table-td:nth-child(3),
#productModule .product-table-th .product-table-td:nth-child(6) {
  flex: 2;
}

#productModule .product-table-tr {
  display: flex;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
}
#productModule .product-table-tr:hover,
#productModule .product-table-tr:hover .product-table-td:first-child {
  background: var(--ebc-neutral-bg_b);
}
#productModule .product-table-tr .product-table-td {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1.5;
  color: var(--ebc-text-primary);
  line-height: 1em;
  padding: 32rem 0;
}
#productModule .product-table-tr .product-table-td:nth-child(2),
#productModule .product-table-tr .product-table-td:nth-child(3),
#productModule .product-table-th .product-table-td:nth-child(2),
#productModule .product-table-th .product-table-td:nth-child(3) {
  text-align: left;
  justify-content: flex-start;
}

#productModule .product-table-tr .product-table-td:first-child {
  flex: 4;
  justify-content: flex-start;
  padding-left: 24rem;
}
#productModule.es .product-table-tr .product-table-td:first-child,
#productModule.es .product-table-th .product-table-td:first-child {
  flex: 3;
}
#productModule.pt .product-table-tr .product-table-td:nth-child(5),
#productModule.pt .product-table-th .product-table-td:nth-child(5),
#productModule.es .product-table-tr .product-table-td:nth-child(5),
#productModule.es .product-table-th .product-table-td:nth-child(5) {
  flex: 2;
}
#productModule .product-table-tr .product-table-td:nth-child(2),
#productModule .product-table-tr .product-table-td:nth-child(3),
#productModule .product-table-tr .product-table-td:nth-child(6) {
  flex: 2;
}

/* #productModule .grow-product-table .product-table-tr .product-table-td {
    width: 23.99%;
  } */

#productModule .rotate90 {
  transform: rotate(-90deg);
  margin-left: 4rem;
}

#productModule .rotate180 {
  transform: rotate(180deg);
}

#productModule .product-innertable {
  background-color: #fff;
}

#productModule .product-innertable-th {
  display: flex;
  height: 64rem;
  color: var(--ebc-text-secondary);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding-right: 12rem;
}
#productModule.ar .product-innertable-tbody,
#productModule.ar .product-innertable-tr,
#productModule.ar .product-innertable-th {
  padding-right: 0;
  padding-left: 12rem;
}
#productModule .product-innertable-th .product-innertable-td:first-child {
  justify-content: flex-start;
  flex: 0.6;
}
#productModule .product-innertable-th .product-innertable-td {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
}
#productModule .product-innertable-th .product-innertable-td .iconfont {
  margin-left: 4rem;
}
#productModule.ar .product-innertable-th .product-innertable-td .iconfont {
  margin-right: 4rem;
  margin-left: unset;
}

/* #productModule
    .grow-product-table
    .product-innertable-th
    .product-innertable-td {
    width: 23.99%;
  } */
#productModule .product-innertable-tbody {
  height: 320rem;
  overflow-y: auto;
  padding-right: 12rem;
}
#productModule .product-innertable-tr {
  display: flex;
  height: 64rem;
  background: #fff;
}

#productModule .product-innertable-tr .product-innertable-td:nth-child(1) {
  flex: 0.6;
  justify-content: flex-start;
}
#productModule .product-innertable-tr .product-innertable-td {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 1;
  color: var(--ebc-text-primary);
}

/* #productModule
    .grow-product-table
    .product-innertable-tr
    .product-innertable-td {
    width: 23.99%;
  } */

#productModule .product-red {
  color: #cd2626 !important;
}

#productModule .product-green {
  color: #0eb565 !important;
}

@media (max-width: 996px) {
#productModule .product-table-tr:hover,
#productModule .product-table-tr:hover .product-table-td:first-child {
  background: #fff;
}
  #productModule {
    margin-top: 80rem;
  }
  /* #productModule .product-table {
      min-width: fit-content;
    } */
  #productModule .iBtn {
    display: none;
  }
  #productModule .product-box {
    overflow-x: auto;
    max-width: calc(100vw - 32rem);
    padding-bottom: 32rem;
  }
  /* 伪滚动条容器 */
  #productModule .fake-scrollbar {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 90rem;
    height: 4px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    pointer-events: none;
    z-index: 9;
  }
  .innerTableContainer .fake-scrollbar {
    bottom: -55rem !important;
  }
  /* 伪滑块 */
  #productModule .fake-thumb {
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 2px;
    width: 0; /* js 动态算 */
    transition: width 0.2s;
  }
  #productModule .pageNavigation span {
    font-size: 40rem;
    margin-left: 8rem;
  }
  #productModule .pageNavigation span.notAllow {
    pointer-events: none;
    color: var(--ebc-text-tertiary);
  }
  #productModule .pageNavigation span:nth-child(1) {
    margin-right: 8rem;
  }
  #productModule .pageNavigation {
    gap: 8rem;
    padding-top: 48rem;
  }
  #productModule .pageNavigation div {
    padding: 4rem 18rem;
  }
  #productModule .pageNavigation .active {
    font-weight: 500;
    background: var(--ebc-neutral-bg_c);
    border-radius: 50%;
  }
  #productModule .product-table::-webkit-scrollbar,
  #productModule .product-box::-webkit-scrollbar {
    display: none;
  }

  #productModule .product-table-th .product-table-td {
    color: var(--ebc-text-secondary);
    padding: 16rem 0;
    justify-content: flex-end;
  }
  #productModule .product-table-th .product-table-td:nth-child(4),
  #productModule .product-table-th .product-table-td:nth-child(6) {
    justify-content: center;
  }
  #productModule .product-table-tr .product-table-td {
    white-space: nowrap;
    padding: 32rem 0;
  }

  #productModule .product-table-tr,
  #productModule .product-table-th {
    gap: 32rem;
    padding-right: 100rem;
    position: relative;
    width: fit-content;
  }
  #productModule.ar .product-table-tr .product-table-td:first-child,
  #productModule.ar .product-table-th .product-table-td:first-child {
    left: unset;
    right: 0;
  }
  #productModule.ar .product-table-tr,
  #productModule.ar .product-table-th {
    padding-left: 100rem;
    padding-right: 0;
  }
  #productModule .product-table-tr .product-table-td:first-child,
  #productModule .product-table-th .product-table-td:first-child {
    flex-direction: column;
    flex: 0 0 160rem;
    width: 160rem;
    padding-left: 0;
    align-items: flex-start;
    justify-content: center;
    gap: 8rem;
    position: sticky;
    left: 0;
    background: var(--ebc-basecolor-white-100);
  }
  .mn #productModule .product-table-tr .product-table-td:first-child,
  .mn #productModule .product-table-th .product-table-td:first-child {
    flex: 0 0 210rem;
    width: 210rem;
  }
  #productModule .product-table-tr .product-table-td:nth-child(2),
  #productModule .product-table-tr .product-table-td:nth-child(3),
  #productModule .product-table-tr .product-table-td:nth-child(5) {
    justify-content: flex-end;
  }
  .noScroll .product-table-tr .product-table-td:first-child::after,
  .noScroll .product-table-th .product-table-td:first-child::after {
    display: none !important;
  }
  #productModule .product-table-tr .product-table-td:first-child::after,
  #productModule .product-table-th .product-table-td:first-child::after {
    content: "";
    position: absolute;
    top: 0;
    right: -8px; /* 控制阴影条水平位置 */
    width: 8px; /* 阴影条宽度 */
    height: 100%; /* 贯穿整个行高 */
    background: linear-gradient(to right, rgba(0, 0, 0, 0.08), transparent);
    pointer-events: none; /* 不影响点击 */
  }
  #productModule.ar .product-table-tr .product-table-td:first-child::after,
  #productModule.ar .product-table-th .product-table-td:first-child::after {
    right: unset;
    left: -8px;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.08), transparent);
  }
  #productModule .product-table-tr .product-table-td:nth-child(2),
  #productModule .product-table-tr .product-table-td:nth-child(3),
  #productModule .product-table-th .product-table-td:nth-child(2),
  #productModule .product-table-th .product-table-td:nth-child(3) {
    flex: 0 0 112rem;
    width: 112rem;
  }
  #productModule.jp .product-table-tr .product-table-td:nth-child(4),
  #productModule.jp .product-table-th .product-table-td:nth-child(4),
  #productModule.kr .product-table-tr .product-table-td:nth-child(4),
  #productModule.kr .product-table-th .product-table-td:nth-child(4) {
    flex: 0 0 120rem;
    width: 120rem;
  }
  #productModule .product-table-tr .product-table-td:nth-child(4),
  #productModule .product-table-th .product-table-td:nth-child(4) {
    flex: 0 0 80rem;
    width: 80rem;
  }
  #productModule .product-table-tr .product-table-td:nth-child(6),
  #productModule .product-table-th .product-table-td:nth-child(6) {
    flex: 0 0 128rem;
    width: 128rem;
  }
  #productModule.es .product-table-tr .product-table-td:nth-child(5),
  #productModule.es .product-table-th .product-table-td:nth-child(5) {
    flex: 0 0 200rem;
    width: 200rem;
  }
  #productModule.es .product-table-tr .product-table-td:nth-child(6),
  #productModule.es .product-table-th .product-table-td:nth-child(6) {
    flex: 0 0 160rem;
    width: 160rem;
  }
  #productModule.jp .product-table-tr .product-table-td:nth-child(6),
  #productModule.jp .product-table-th .product-table-td:nth-child(6) {
    flex: 0 0 160rem;
    width: 160rem;
  }
  #productModule.mn .product-table-tr .product-table-td:nth-child(6),
  #productModule.mn .product-table-th .product-table-td:nth-child(6),
  #productModule.pt .product-table-tr .product-table-td:nth-child(6),
  #productModule.pt .product-table-th .product-table-td:nth-child(6) {
    flex: 0 0 240rem;
    width: 240rem;
  }
  #productModule.jp .product-table-tr .product-table-td:nth-child(5),
  #productModule.jp .product-table-th .product-table-td:nth-child(5) {
    flex: 0 0 150rem;
    width: 150rem;
  }
  #productModule.pt .product-table-tr .product-table-td:nth-child(5),
  #productModule.pt .product-table-th .product-table-td:nth-child(5) {
    flex: 0 0 200rem;
    width: 200rem;
  }
  #productModule .product-table-tr .product-table-td:nth-child(5),
  #productModule .product-table-th .product-table-td:nth-child(5) {
    flex: 0 0 96rem;
    width: 96rem;
    order: 2;
  }
  .formPopup {
    width: 100%;
    bottom: -110%;
    left: 0;
    transform: scale(0);
    top: unset;
    border-radius: 32rem 32rem 0 0;
    padding: 48rem 32rem 96rem;
  }
  .showFormPopup {
    bottom: 0;
    transform: scale(1);
  }
  .formPopup h2 {
    max-width: 75vw;
  }
  .formPopup h3 {
    margin: 16rem 0 48rem;
  }
  .formPopup svg {
    top: 55rem;
    right: 32rem;
    width: 48rem;
    height: 48rem;
  }
  .ar .formPopup svg {
    right: unset;
    left: 32rem;
  }
  .formPopup .product-table {
    max-width: calc(100vw - 64rem);
    overflow: auto;
    padding-bottom: 16rem;
  }
  .formPopup .product-table-row {
    position: relative;
  }

  /* .formPopup .product-table::-webkit-scrollbar{
      display: none;
    } */
  .formPopup .product-table .product-innertable-th,
  .formPopup .product-table .product-innertable-tr {
    padding-right: 24rem;
  }
  .formPopup .product-table .product-innertable-tr,
  .formPopup .product-table .product-innertable-th {
    gap: 48rem;
    /* width:fit-content; */
  }
  .formPopup .product-table .product-innertable-th {
    white-space: nowrap;
  }
  #productModule .product-innertable-th,
  #productModule .product-innertable-tr {
    height: 80rem;
  }
  #productModule .product-innertable-th {
    /* position: sticky; */
    background: var(--ebc-basecolor-white-100);
    /* top:0; */
    /* z-index: 10; */
  }
  #productModule .product-innertable-tbody {
    overflow: visible;
    height: 400rem;
  }
  .formPopup .product-innertable-th {
    width: fit-content;
  }
  .formPopup .product-innertable-td:first-child {
    position: sticky;
    left: 0;
    background: var(--ebc-basecolor-white-100);
    flex: 0 0 114rem !important;
    width: 114rem !important;
  }
  .ar .formPopup .product-innertable-td:first-child {
    left: unset;
    right: 0;
  }

  .formPopup .noScroll .product-innertable-td:first-child::after {
    display: none !important;
  }
  .formPopup .product-innertable-td:first-child::after {
    content: "";
    position: absolute;
    top: 0;
    right: -8px; /* 控制阴影条水平位置 */
    width: 8px; /* 阴影条宽度 */
    height: 100%; /* 贯穿整个行高 */
    background: linear-gradient(to right, rgba(0, 0, 0, 0.08), transparent);
    pointer-events: none; /* 不影响点击 */
  }
  .ar .formPopup .product-innertable-td:first-child::after {
    right: unset;
    left: -8px;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.08), transparent);
  }

  .formPopup .product-innertable-td:nth-child(2) {
    flex: 0 0 112rem !important;
    width: 112rem !important;
  }
  .formPopup .product-innertable-td:last-child {
    flex: 0 0 96rem !important;
    width: 96rem !important;
    justify-content: center !important;
  }
  .formPopup .product-innertable-td {
    flex: 0 0 160rem !important;
    width: 160rem;
  }
  /* 把上下三角重置 */
  .popover::before,
  .popover::after {
    left: -10px; /* 贴到 popover 左侧 */
    top: 50%;
    transform: translateY(-50%);
    border: 6px solid transparent;
  }
  /* 朝左的三角：右边框着色 */
  .popover::before {
    border-right-color: var(--ebc-neutral-bg_d);
  }
  .popover::after {
    left: -6px;
    border-right-color: var(--ebc-neutral-bg_d);
  }
  .ar.popover::before,
  .ar.popover::after {
    left: unset;
    right: -10px;
    border-left-color: var(--ebc-neutral-bg_d);
    border-right-color: transparent;
  }
}
</style>
